import { createFileRoute } from "@tanstack/react-router";
import { getCmsLegalPage } from "@/lib/cms/website.functions";
import { LegalPageView, legalHead } from "@/components/cms/LegalPageView";

const SLUG = "refund-cancellation";
const FALLBACK = "Refund & Cancellation Policy";

export const Route = createFileRoute("/refund-cancellation")({
  loader: () => getCmsLegalPage({ data: { slug: SLUG } }),
  head: ({ loaderData }) => legalHead(loaderData ?? null, FALLBACK, `/${SLUG}`),
  component: () => <LegalPageView page={Route.useLoaderData()} fallbackTitle={FALLBACK} />,
});
